import { Service } from '@tino-frontend/adapters'
import { ContractStatusResponse } from '@types'

export class ContractService {
  constructor(private readonly http: Service) {}

  getContractCollecting(companyId: string): Promise<ContractStatusResponse> {
    return this.http.get(`/v1/company/${companyId}/contract/collecting`)
  }
}
